import React from 'react';
import { Signal, Wifi, BatteryFull } from 'lucide-react';

// iOS-style status bar present across every reference screen.
const StatusBar = () => {
  return (
    <div className="flex items-center justify-between px-6 pt-3 pb-1 select-none">
      <span
        className="text-[15px] font-semibold"
        style={{ color: 'var(--lp-cream)' }}
      >
        9:41
      </span>
      <div className="flex items-center gap-1.5" style={{ color: 'var(--lp-cream)' }}>
        <Signal size={16} strokeWidth={2.4} />
        <Wifi size={16} strokeWidth={2.4} />
        <BatteryFull size={22} strokeWidth={1.8} />
      </div>
    </div>
  );
};

export default StatusBar;
